import { useRef } from "react";

// hold the last loading message so it does not vanish during the fade-out transition
// updated during render (matches the rest of the loading-overlay code path) — concurrent-mode discarded
// renders simply leave the ref unchanged, and the next non-discarded render with loading=true updates it
export const useStickyLoadingMessage = (loadingMessage: string | undefined, loading: boolean): string | undefined => {
    const lastMessage = useRef(loadingMessage);
    if (loading) {
        lastMessage.current = loadingMessage;
    }
    return lastMessage.current;
};
